import { createSelector } from 'reselect';
import type { LegacyProductReference } from 'constants/products';
import { getFavourites, isFavouritesSuccessfullyLoaded } from './get-favourites';

const EMPTY_RECOMMENDED_PRODUCTS: LegacyProductReference[] = [];

export const getFavouritesRecommendedProducts = createSelector([getFavourites], favourites =>
  isFavouritesSuccessfullyLoaded(favourites)
    ? favourites.recommendations
    : EMPTY_RECOMMENDED_PRODUCTS,
);
